import { Box, Button, Divider, Icon, Paper, Skeleton, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import { t } from 'i18next';

interface IFerramentasDeDetalheProps {
  idForm?: string;
  textoBotaoNovo?: string;
  textoBotaoGenerico?: string;
  textoBotaoGenerico2?: string;
  iconeBotaoGenerico?: string;
  iconeBotaoGenerico2?: string;


  mostrarBotaoNovo?: boolean;

  mostrarBotaoVoltar?: boolean;
  mostrarBotaoApagar?: boolean;
  mostrarBotaoSalvar?: boolean;
  mostrarBotaoSalvarEFechar?: boolean;
  mostrarBotaoGenerico?: boolean;
  mostrarBotaoGenerico2?: boolean;
  mostrarBotaoAlteraStatus?: boolean;
  


  mostrarBotaoNovoCarregando?: boolean;
  mostrarBotaoVoltarCarregando?: boolean;
  mostrarBotaoApagarCarregando?: boolean;
  mostrarBotaoSalvarCarregando?: boolean;
  mostrarBotaoSalvarEFecharCarregando?: boolean;
  mostrarBotaoGenericoCarregando?: boolean;
  mostrarBotaoGenerico2Carregando?: boolean;
  mostrarBotaoAlteraStatusCarregando?: boolean;
 

  aoClicarEmNovo?: () => void;
  aoClicarEmVoltar?: () => void;
  aoClicarEmApagar?: () => void;
  aoClicarEmSalvar?: () => void;
  aoClicarEmSalvarEFechar?: () => void;
  aoClicarEmGenerico?: () => void;
  aoClicarEmGenerico2?: () => void;
  handleAlterarStatus?: () => void;
  
}
export const FerramentasDeDetalhe: React.FC<IFerramentasDeDetalheProps> = ({
  textoBotaoNovo = 'Novo',
  textoBotaoGenerico = '',
  textoBotaoGenerico2 = '',
  iconeBotaoGenerico = '',
  iconeBotaoGenerico2 = '',

  idForm = '',
  mostrarBotaoNovo = true,
  mostrarBotaoVoltar = true,
  mostrarBotaoApagar = true,
  mostrarBotaoSalvar = true,
  mostrarBotaoSalvarEFechar = false,
  mostrarBotaoGenerico = false,
  mostrarBotaoGenerico2 = false,
  mostrarBotaoAlteraStatus = false,
  

  mostrarBotaoNovoCarregando = false,
  mostrarBotaoVoltarCarregando = false,
  mostrarBotaoApagarCarregando = false,
  mostrarBotaoSalvarCarregando = false,
  mostrarBotaoSalvarEFecharCarregando = false,
  mostrarBotaoGenericoCarregando = false,
  mostrarBotaoGenerico2Carregando = false,
  mostrarBotaoAlteraStatusCarregando = false,
  


  aoClicarEmNovo,
  aoClicarEmVoltar,
  aoClicarEmApagar,
  aoClicarEmSalvar,
  aoClicarEmSalvarEFechar,
  aoClicarEmGenerico,
  aoClicarEmGenerico2,
  handleAlterarStatus,
 
}) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const theme = useTheme();



  return (
    <Box
      gap={1}
      marginX={1}
      padding={1}
      paddingX={2}
      marginBottom={2}
      display="flex"
      alignItems="center"
      height={theme.spacing(10)}
      component={Paper}
    >

      {(mostrarBotaoVoltar && !mostrarBotaoVoltarCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmVoltar}
          startIcon={<Icon>arrow_back</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {t('components.actions.voltar')}
          </Typography>
        </Button>
      )}
      {(mostrarBotaoSalvar && !mostrarBotaoSalvarCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='contained'
          type='submit'
          form={idForm}
          onClick={aoClicarEmSalvar}
          startIcon={<Icon>save</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {t('components.actions.salvar')}
          </Typography>
        </Button>
      )}

      {mostrarBotaoSalvarCarregando && (
        <Skeleton width={110} height={60} />
      )}

      {(mostrarBotaoSalvarEFechar && !mostrarBotaoSalvarEFecharCarregando && !smDown && !mdDown) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          form={idForm}
          type='submit'
          onClick={aoClicarEmSalvarEFechar}
          startIcon={<Icon>save</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {t('components.actions.saveclose')}
          </Typography>
        </Button>
      )}

      {(mostrarBotaoSalvarEFecharCarregando && !smDown && !mdDown) && (
        <Skeleton width={180} height={60} />
      )}

      {(mostrarBotaoApagar && !mostrarBotaoApagarCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmApagar}
          startIcon={<Icon>delete</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {t('components.actions.apagar')}
          </Typography>
        </Button>
      )}

      {mostrarBotaoApagarCarregando && (
        <Skeleton width={110} height={60} />
      )}

      {(mostrarBotaoNovo && !mostrarBotaoNovoCarregando && !smDown) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmNovo}
          startIcon={<Icon>add</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {textoBotaoNovo}
          </Typography>
        </Button>
      )}

      {(mostrarBotaoNovoCarregando && !smDown) && (
        <Skeleton width={110} height={60} />
      )}

      {
        (
          mostrarBotaoVoltar &&
          (mostrarBotaoNovo || mostrarBotaoApagar || mostrarBotaoSalvar || mostrarBotaoSalvarEFechar)
        ) && (
          <Divider variant='middle' orientation='vertical' />
        )
      }



      {mostrarBotaoVoltarCarregando && (
        <Skeleton width={110} height={60} />
      )}

      {(mostrarBotaoGenerico && !mostrarBotaoGenericoCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmGenerico}
          startIcon={<Icon>{iconeBotaoGenerico}</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {textoBotaoGenerico}
          </Typography>
        </Button>
      )}
      {(mostrarBotaoGenerico2 && !mostrarBotaoGenerico2Carregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmGenerico2}
          startIcon={<Icon>{iconeBotaoGenerico2}</Icon>}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {textoBotaoGenerico2}
          </Typography>
        </Button>
      )}

      {(mostrarBotaoAlteraStatus && !mostrarBotaoAlteraStatusCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={handleAlterarStatus}

        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Alterar Status
          </Typography>
        </Button>
      )}
     

      {mostrarBotaoGenericoCarregando && (
        <Skeleton width={110} height={60} />
      )}
    </Box >
  );
};
